import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

const QUERY = gql`
  query {
    countries {
      code
      name
      currency
    }
  }
`;

const useCountries = () => {
  const { data, loading, error } = useQuery(QUERY);

  return loading || error ? [] : data.countries;
};

export default useCountries;
